/**
 * HomologationBanner (T12) — the dev/CNDA-only INSi homologation surface.
 *
 * A persistent banner with a scenario `<select>` and a "capture" toggle. Rendered
 * ONLY when `INSI_HOMOLOGATION_ENABLED` (build-time flag) is on, so it never ships
 * to production. The chosen scenario/capture drive the headers injected on the
 * next INSi search (tech_design_spec §9).
 */
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import {
  HOMOLOGATION_SCENARIO_IDS,
  HOMOLOGATION_SCENARIO_LABELS,
} from 'services/insi/constants';
import { INSI_HOMOLOGATION_ENABLED } from 'config';
import { useHomologation } from './HomologationContext';

export default function HomologationBanner() {
  const { t } = useTranslation();
  const {
    scenarioId,
    setScenarioId,
    captureRequested,
    setCaptureRequested,
  } = useHomologation();

  // Build-time guard: nothing renders in a normal/production build.
  if (!INSI_HOMOLOGATION_ENABLED) return null;

  return (
    <SBar data-id="insi-homologation-banner">
      <span className="tag">{t('INSi homologation mode')}</span>

      <label>
        {t('Scenario')}:&nbsp;
        <select
          data-id="insi-homologation-scenario"
          value={scenarioId}
          onChange={(e) => setScenarioId(e.target.value)}
        >
          {/* Empty value = homologation off (no scenario header sent). */}
          <option value="">{t('Off (no scenario)')}</option>
          {HOMOLOGATION_SCENARIO_IDS.map((id) => (
            <option key={id} value={id}>
              {HOMOLOGATION_SCENARIO_LABELS[id]
                ? `${id} — ${HOMOLOGATION_SCENARIO_LABELS[id]}`
                : id}
            </option>
          ))}
        </select>
      </label>

      <label>
        <input
          type="checkbox"
          data-id="insi-homologation-capture"
          checked={captureRequested}
          onChange={(e) => setCaptureRequested(e.target.checked)}
        />
        &nbsp;{t('Capture request')}
      </label>
    </SBar>
  );
}

const SBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1400;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 6px 16px;
  background: #ffb300;
  color: #1a1a1a;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.2);

  .tag {
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  select,
  input {
    cursor: pointer;
  }
`;
